import { Link } from "react-router-dom"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const Howtoapply = () => {
    const homeMenu = [
        { label: "Admission Notification ", link: "/howtoapply" },
        { label: "Fee Structure", link: "/feestructure" },
        { label: "Prospectus ", link: "/Prospectus" },
        { label: "Virtual School Tour ", link: "https://iviewd.com/lotus_valley_gurgaon/" },
        { label: "School Schedule ", link: "/schoolSchedule" },
        {
            label: "Transport", link: "", subMenu: [
                { label: "Transport", link: "/transport" },
                { label: "Bus Routes", link: "/busRoute" },
            ]
        },

        { label: "Special Education", link: "/specialEdu" },
        { label: "Bonding With Parents", link: "/bondingwithparents" },
        // { label: "Career Counselling", link: "/careerCounselling" },
        { label: "Meal Menu", link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/School-Menu.pdf" },
        { label: "CBSE Results", link: "/CBSEResult" },
        { label: "Transfer Certificate", link: "/tc" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/apply.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page admission">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="How to Apply" breadEnd="How to Apply" breadMid="How to Apply" />
                        </div>
                        <div className="col-md-12">
                            <div className="text-center">
                                <h4>Admission Notification – Academic Session (2026-27)
</h4>
                                <h4><span>Registrations for Admission Opens for</span></h4>
                                <h4 className="color-blue font-normal">FOUNDATIONAL STAGES- FS1 / FS2 / Grade-I
</h4>
                            </div>
                            <p>The age eligibility criteria as on 1st April 2026 is in alignment with NEP guidelines (strictly abiding)


</p>
                            <ul class="admission-list">
                                <li className="">FS 1 is 3+yrs
</li>
                                <li className="">FS 2 is 4+yrs
</li>
                                <li className="">FS 3 is 5+yrs ( NO VACANCY)
</li>
                                <li className="">Grade1 6+yrs</li>
                            </ul>
                            <div className="text-center">
                                <h4 className="color-blue text-left">Registration Forms will be available online for Admission w.e.f. 28th to 31st July’2025.
                                </h4>   
                            </div>
                            <p> Duly  filled in <strong>Registration Form</strong> completed in all respects must be submitted online <strong><em><u>latest by Thursday, 31<sup>st</sup> July 2025 (12:00pm midnight) <br /> </u></em></strong> </p> 
                            <h4 className="color-blue text-left">No forms will be accepted later than the given date.</h4>   
                            <ul class="admission-list">
                                <li>Filling and submission of online Registration Form <span className="color-blue">does not guarantee admission </span>to the school.</li>
                                <li className="color-blue text-left">The Registration fee amount is non-refundable</li>
                                <li>All valid applications will be considered for Admission.</li>
                                <li>Incomplete / Incorrect Registration Form will not be processed.</li>
                                <li>There will be no screening, written test, interview or profiling of child/parent.</li>
                                <li className="color-blue">Priority will be given to children fulfilling the Age & Neighborhood criteria (FS1/FS2)</li>
                                <li>In case there is no vacancy, the application will not be processed.</li>
                                <li>Admission will be granted post verification of documents & online Registration Form submitted</li>
                                <li>The <u className="color-blue">Fee payment should be made within 2 days </u>after confirmation of Admission .</li>
                            </ul>
                            <p><i><span><b>In case of any Non-Compliance, the admission will stand cancelled.</b></span></i></p>
                            <ul class="admission-list">
                                <li>The Mode of payment for Admission has to be through <b className="color-blue"> NEFT / DEMAND DRAFT</b> only in favour of <span className="color-blue"><i>Lotus Valley International School, Gurgaon</i>.</span></li>
                            </ul>
                            <h4 className="color-blue mb-4">Pre-requisites at the time of submission of Admission Form</h4>
                            <div className="table-responsive strong-color howtbl">
                                <table cellpadding="0" cellspacing="0" width="100%" border="1">
                                    <tbody><tr>
                                        <td>
                                            <p className="mb-0"><strong><span>CRITERIA</span></strong></p></td>
                                        <td><p className="mb-0"><strong><span>DOCUMENTS TO BE SUBMITTED (MADATORY)</span></strong></p></td>
                                    </tr>
                                        <tr>
                                            <td><p><strong><span>Mode of  Payment</span></strong></p></td>
                                            <td><ul class="admission-list">
                                                <li>Parents should carry Demand Draft of the    said mentioned amount at the time of submission of Admission Form.</li>
                                                <li>Transfer of fee through    NEFT as per the under mentioned details: </li>
                                            </ul>
                                                <p className="color-blue">Account Holder’s  -  Name<br />
                                                    Lotus Valley International School, Gurgaon <br />
                                                    Account number - '628401064387 <br />
                                                    IFSC Code - ICIC0006284<br />
                                                    Bank’s Name - ICICI BANK</p>
                                                <ul class="admission-list">
                                                    <li>Also    confirm the same sending the screen shot of the payment at: </li>
                                                </ul>
                                                <p><Link to="mailto:Info@lotusvalleygurgaon.com" target="_blank" rel="noreferrer" className="color-blue">admissions@lotusvalleygurgaon.com</Link><strong> </strong></p></td>
                                        </tr>
                                        <tr>
                                            <td><p><strong>Photographs</strong><br />
                                                <strong>(at the time    of submission of Admission Form)</strong></p></td>
                                            <td>
                                                <ul class="admission-list">
                                                    <li>2 recent photographs of the child</li>
                                                </ul>
                                                <p> </p></td>
                                        </tr>
                                        <tr>
                                            <td><p><strong>Proof of Age&nbsp; (Self Attested)</strong></p></td>
                                            <td><ul class="admission-list">
                                                <li>Copy of the Birth Certificate<strong className="color-blue">(mandatory)</strong></li>
                                                <li>Passport (in case name not    mentioned in Birth certificate)-optional </li>
                                                <li>Copy of Aadhaar&nbsp; Card <strong className="color-blue">(mandatory</strong>) </li>
                                            </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p><strong>Proof of Residence</strong><br />
                                                    <strong>(any one of the mentioned documents)</strong></p>
                                            </td>
                                            <td>
                                                <ul class="admission-list">
                                                    <li>Passport</li>
                                                    <li>Lease Deed</li>
                                                    <li>Bank Statement/passbook</li>
                                                    <li>Utility Bill (water,      electricity, phone)</li>
                                                    <li>Rent Agreement/ Deed</li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody></table>
                            </div>

                            <h4 className="mt-4 color-blue"><u>Withdrawal Guidelines:</u></h4>
                            <ul className="admission-list">
                                <li>Please Note that <span className="color-blue">Admission Fee is a non-refundable component </span>and will not be refunded in case of withdrawal or request at any time of the year.</li>
                                <li>As per school rules in case of withdrawal 2 months’ prior intimation is required before the start of the new academic session <span>(new admission).</span> Failing which only caution money will be refunded rest all components would be forfeited.</li>
                            </ul>
                            
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>

    )

}
export default Howtoapply
